module.exports = __webpack_public_path__ + "img/card_informe_compu_appointment.9101bdf1.svg";